/* eslint-disable eqeqeq */
import React, { useState, useCallback, useEffect } from "react";

/** Components */
import { TableContainer, TableHead, TableRow, TableCell, TableBody, Table, Paper, Collapse, Typography } from "@mui/material";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import LoadingProgress from "../../commons/LoadingProgress.component";
import CustomDatePicker from "../../commons/CustomDatePicker";
import { useSnackbar } from "notistack";

/** Icons */

/** Api & Function */
import { getCustomers, getRPTErppt } from "../../../services/api";

/** Package */
import dayjs from "dayjs";
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
// import { ExcelIcon } from "../../commons/miscellaneous";
import { moneyFormat } from "../../config";

const initialFilter = {
  customer: null,
  date: "",
};

const SubSaleDebt = ({ open, tab }) => {
  // custom hook
  const [t] = useTranslation();

  const { enqueueSnackbar } = useSnackbar();
  // state
  const [isAllow, setAllow] = useState(true);
  const [arrayData, setArrayData] = useState([]);
  const [input, setInput] = useState({ ...initialFilter, date: dayjs().format("YYYY-MM-DD") });

  // methods
  const handleSearch = useCallback(
    async () => {
      setArrayData();
      const params = {};
      if (input.customer) params.customer_id = input.customer.id;
      if (input.date) params.date = input.date;
      return getRPTErppt(params).then((res) => {
        if (res.code === 403) {
          setAllow(false);
          setArrayData([]);
          return;
        }
        if (res.code !== 200) {
          enqueueSnackbar(res.message);
          setArrayData([]);
          return;
        }
        setArrayData(res.data);
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [input]
  );

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div align="right" style={{ marginRight: 10 }}>
      <Collapse in={open}>
        <FilterBy
          style={{ display: "inline-flex", margin: 5, minWidth: 400 }}
          getDataFunc={() => getCustomers({ status: 1 })}
          value={input.customer || null}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
          label={t("Khách hàng")}
          renderOption={(props, option) => (
            <Typography style={{ fontSize: 12 }} {...props}>
              {option.name}
            </Typography>
          )}
        />
        <CustomDatePicker label={t("Ngày kết thúc")} value={input.date} onChange={(value) => setInput((prev) => ({ ...prev, date: value }))} sx={{ margin: "5px" }} />
        <ButtonWithAPICall api={handleSearch} disableSnackbar={() => true} variant="outlined">
          {t("Tìm kiếm")}
        </ButtonWithAPICall>
      </Collapse>
      <div>
        {!arrayData ? (
          <LoadingProgress />
        ) : (
          <TableContainer component={Paper} style={{ width: "99%", marginLeft: 5 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    STT
                  </TableCell>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Tên khách hàng
                  </TableCell>
                  <TableCell rowSpan={2} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Tiền tệ
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Tổng tiền chưa phân bổ
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Ngày trả lần cuối
                  </TableCell>
                  <TableCell rowSpan={1} style={{ border: "1px solid lightgray" }} colSpan={1}>
                    Cập nhật lần cuối
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody suppressHydrationWarning>
                {arrayData?.length ? (
                  arrayData.map((row, index) => (
                    // <TableRow hover component={Link} to={`/debt?customer_id=${row.customer_id}&start_date=${input.start_date}&end_date=${input.end_date}`} key={index}>
                    <TableRow key={index}>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="left">
                        {row.customer_name}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }}>
                        {row.currency}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moneyFormat(row.rst_amount, row.currency)}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moment(row.ptp_date).format("DD/MM/YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell component="div" style={{ border: "1px solid lightgray" }} align="right">
                        {moment(row.updated_at).format("DD/MM/YYYY HH:mm:ss")}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={20}>
                      {t(isAllow ? "Không có dữ liệu" : "No permission")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default SubSaleDebt;
